import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Track from '../../tracking/ZorseTicketInspectorTracker';
import { jsx as _jsx } from "react/jsx-runtime";
function MoreResultsButton(props) {
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "more-results-button-internal",
    onClick: () => {
      Track.moreResultsOpened();
      props.onClick();
    },
    size: "sm",
    use: "tertiary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.search.card.openMoreResults"
    })
  });
}
MoreResultsButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(MoreResultsButton);